import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/background.png'


const _withScopeId = n => (_pushScopeId("data-v-5ca1391c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "background-image"
}
const _hoisted_2 = { class: "login-container" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "It's time to stir things up", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Support a fast and efficient check-in process.", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  style: {"text-align":"left","margin-top":"30px"}
}
const _hoisted_8 = { class: "ion-margin-top ion-text-center" }
const _hoisted_9 = {
  key: 1,
  class: "container"
}
const _hoisted_10 = { class: "ion-margin-top ion-text-center" }

import { onIonViewWillEnter, useIonRouter } from "@ionic/vue";
import { logIn } from "ionicons/icons";
import {
  IonLabel,
  IonLoading,
  IonItem,
  IonInput,
  IonButton,
  IonPage,
  IonNote,
  IonContent,
  IonIcon,
} from "@ionic/vue";
import { reactive } from "vue";
import { useMyAccount } from "../";
import { useUserStore } from "@/stores/user";
import { useWindowWidth } from "@/composition/window";
import { event as gtag_event } from "vue-gtag";


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const router = useIonRouter();
const { isMobile } = useWindowWidth();

const { loginForm } = useMyAccount();

const state = reactive({
  loading: false,
  errorMessage: "",
});

const userStore = useUserStore();

onIonViewWillEnter(() => {
  userStore.setUserLogout();
});

const login = async () => {
  state.loading = true;
  userStore
    .login({
      username: loginForm.email,
      password: loginForm.password,
    })
    .then(async () => {
      gtag_event("login", {
        category: "check-in app",
        label: "Login successfully",
      });
      await userStore.fetchMe();
      await userStore.fetchRoles();
      state.loading = false;

      const { events } = userStore.related;
      if (!userStore.userIsAdmin) {
        if (events && events.length === 1) {
          router.push(`/event/${userStore.related.events[0].id}/home`);
        } else if (events && events.length > 1) {
          router.push("/home");
        } else {
          router.push("/onboarding/new-event");
        }
      } else {
        router.push("/home");
      }
    })
    .catch(() => {
      state.loading = false;
      state.errorMessage = "Your email or password are incorrect";
    });
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          (!_unref(isMobile))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            (_unref(isMobile))
              ? (_openBlock(), _createElementBlock("img", _hoisted_3))
              : _createCommentVNode("", true),
            _createElementVNode("section", {
              style: _normalizeStyle(_unref(isMobile) ? '' : 'text-align: center;')
            }, [
              _createElementVNode("div", {
                class: _normalizeClass({ container: !_unref(isMobile) })
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass({ container: _unref(isMobile) })
                }, _hoisted_6, 2),
                _createElementVNode("div", {
                  style: _normalizeStyle(_unref(isMobile) ? '' : 'max-width: 600px; margin: 0 auto')
                }, [
                  _createVNode(_unref(IonItem), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Email")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        modelValue: _unref(loginForm).email,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(loginForm).email) = $event)),
                        name: "email",
                        placeholder: "john.doe@email.com",
                        type: "email"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonItem), {
                    class: _normalizeClass({ 'ion-invalid': state.errorMessage !== '' })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Password")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        name: "password",
                        modelValue: _unref(loginForm).password,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(loginForm).password) = $event)),
                        type: "password",
                        placeholder: "******"
                      }, null, 8, ["modelValue"]),
                      (state.errorMessage !== '')
                        ? (_openBlock(), _createBlock(_unref(IonNote), {
                            key: 0,
                            slot: "error"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(state.errorMessage), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  (!_unref(isMobile))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_router_link, { to: `/reset-password` }, {
                          default: _withCtx(() => [
                            _createTextVNode("Forgot password?")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonButton), {
                          expand: "block",
                          color: "primary",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (login())),
                          class: "ion-margin-top login-button"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonIcon), {
                              slot: "start",
                              icon: _unref(logIn)
                            }, null, 8, ["icon"]),
                            _createTextVNode(" Login ")
                          ]),
                          _: 1
                        }),
                        _createElementVNode("p", _hoisted_8, [
                          _createTextVNode(" No account yet? "),
                          _createVNode(_component_router_link, { to: `/onboarding/introduction` }, {
                            default: _withCtx(() => [
                              _createTextVNode("Sign up.")
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 4)
              ], 2)
            ], 4),
            (_unref(isMobile))
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("section", null, [
                    _createVNode(_component_router_link, { to: `/reset-password` }, {
                      default: _withCtx(() => [
                        _createTextVNode("Forgot password?")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonButton), {
                      expand: "block",
                      color: "primary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (login())),
                      class: "ion-margin-top login-button"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonIcon), {
                          slot: "start",
                          icon: _unref(logIn)
                        }, null, 8, ["icon"]),
                        _createTextVNode(" Login ")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("p", _hoisted_10, [
                      _createTextVNode(" No account yet? "),
                      _createVNode(_component_router_link, { to: `/onboarding/introduction` }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sign up.")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(IonLoading), {
        "is-open": state.loading,
        message: "Please wait..."
      }, null, 8, ["is-open"])
    ]),
    _: 1
  }))
}
}

})